(() => {
  const readOptimizedHeaderExperiment = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );

    const enabled = holdoutGroup !== "holdout-q3-2026";

    document.body.classList.toggle("pdm-optimized-header", enabled);

    if (!enabled) return;

    const $header = document.querySelector(".section-header");
    const $announcement = $header?.querySelector(".header-announcement");
    const $menu = $header?.querySelector(".section-header--content");
    if (!$header || !$announcement) return;

    const HIDE_THRESHOLD = 40;
    const DELTA_THRESHOLD = 6;
    const body = document.body;
    const rootStyle = document.documentElement.style;

    const publishHeights = () => {
      rootStyle.setProperty(
        "--announcement-height",
        `${$announcement.offsetHeight}px`,
      );
      if ($menu)
        rootStyle.setProperty("--menu-height", `${$menu.offsetHeight}px`);
    };
    publishHeights();
    window.addEventListener("load", publishHeights);
    window.addEventListener("resize", publishHeights, { passive: true });

    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      const currentY = window.scrollY;
      const delta = currentY - lastY;

      if (Math.abs(delta) >= DELTA_THRESHOLD) {
        if (currentY <= HIDE_THRESHOLD) {
          body.classList.remove("is-scrolled", "is-menu-visible");
        } else {
          body.classList.add("is-scrolled");
          body.classList.toggle("is-menu-visible", delta < 0);
        }
        lastY = currentY;
      }
      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(onScroll);
      },
      { passive: true },
    );
  };

  const readPLPBadge = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    if (holdoutGroup !== "holdout-q3-2026") {
      document.body.dataset.badge = "B";
    }
  };

  const readSidecartCheckoutPosition = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    const enabled = holdoutGroup !== "holdout-q3-2026";

    const position = enabled ? "bottom" : "top";

    if (position !== "top" && position !== "bottom") return;

    document.body.setAttribute("data-checkout-position", position);
  };

  const readBeamWidgetPdp = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const forcedValue = Number(urlParams.get("pdm-beam-widget")) || 0;
    const isPLPBadgeFlag = Number(
      window._growthbook.getFeatureValue("beam-widget-pdp", 0),
    );
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    const enabled = holdoutGroup !== "holdout-q3-2026";
    const variant = !enabled ? 0 : isPLPBadgeFlag || forcedValue;

    if (variant === 1) {
      document.body.dataset.beamWidgetPdp = "B";
    }
  };

  const readShopBy = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    const featureFlag = window._growthbook.getFeatureValue(
      "pdm-shop-by",
      false,
    );
    const enabled = holdoutGroup !== "holdout-q3-2026";

    if (enabled && featureFlag) {
      document.body.setAttribute("data-pdm-shop-by", "true");
    }
  };

  const readHeroBannerOptimization = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    const flagValue = window._growthbook.getFeatureValue(
      "pdm-hero-banner-optimization",
      false,
    );
    if (holdoutGroup !== "holdout-q3-2026" && flagValue) {
      document.body.dataset.hero = "B";
      if (typeof window.swiperInitHero === "function") {
        window.swiperInitHero();
      } else {
        document.addEventListener(
          "swiperHeroReady",
          () => window.swiperInitHero(),
          { once: true },
        );
      }
    }
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(() => {
    const applyFeatureFlags = () => {
      readOptimizedHeaderExperiment();
      readPLPBadge();
      readSidecartCheckoutPosition();
      readBeamWidgetPdp();
      readShopBy();
      readHeroBannerOptimization();
    };

    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();
